<span class="icon-inline">
  <i
    v-tooltip.bottom="tooltipOptions"
    class="bi bi-lightning-charge-fill"
    :style="{ color: color, fontSize: size }"
    aria-hidden="true"
  ></i>
</span>
